import { createClient, SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseServiceKey = import.meta.env.VITE_SUPABASE_SERVICE_ROLE_KEY;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl) {
  throw new Error('VITE_SUPABASE_URL이 설정되지 않았습니다');
}

// Admin용 클라이언트 (Service Role Key)
// 데이터 CRUD 작업에 사용
let adminClient: SupabaseClient | null = null;

export const getSupabaseAdmin = (): SupabaseClient => {
  if (!adminClient) {
    if (!supabaseServiceKey) {
      throw new Error('VITE_SUPABASE_SERVICE_ROLE_KEY가 설정되지 않았습니다');
    }
    adminClient = createClient(supabaseUrl, supabaseServiceKey, {
      auth: {
        persistSession: true, // 세션 유지 활성화
        autoRefreshToken: true, // 토큰 자동 갱신 활성화
        detectSessionInUrl: false, // URL에서 세션 감지 비활성화
        storageKey: 'catchu-admin-auth', // Admin 전용 storage key
      },
      global: {
        headers: {
          'X-Client-Info': 'catchu-admin-client', // Admin 클라이언트 식별
        }
      }
    });
  }
  return adminClient;
};

// Auth용 클라이언트 (Anon Key)
// 사용자 인증에만 사용
let authClient: SupabaseClient | null = null;

export const getSupabaseAuth = (): SupabaseClient => {
  if (!authClient) {
    if (!supabaseAnonKey) {
      throw new Error('VITE_SUPABASE_ANON_KEY가 설정되지 않았습니다');
    }
    authClient = createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true, // Auth 클라이언트만 세션 저장
        autoRefreshToken: true,
        detectSessionInUrl: true,
        storageKey: 'supabase-user-auth', // User 전용 storage key
      }
    });
  }
  return authClient;
};

// 편의를 위한 직접 export
export const supabaseAdmin = getSupabaseAdmin();
